"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.defaultProps = exports.propTypes = exports.config = void 0;

var _spauiUtils = require("@tencent/spaui-utils");

var _clear_component = _interopRequireDefault(require("./component/clear_component"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * Tencent is pleased to support the open source community by making SPA UI available.
 * Copyright (C) 2019, a Tencent company. All rights reserved.
 */

/**
 * @fileoverview 组件参数配置
 */

/**
 * Labels 接口参数
 * @alias LabelsProps
 * @description 进行标记和分类的标签。
 * @property {titleline} 默认支持参数
 * @property {blankline} className;style;id;data-*;accessKey;dir;draggable;tabIndex;title;htmlRef;
 * @property {string} [className=''] className='mini'的时候为小尺寸;
 * @property {titleline} 基础属性
 * @property {array} data=[]] 展示的数据
 * @property {func} [onChange] 切换状态回调函数*onChange = (event, data)   // data:值*
 * @property {bool} [multiple=true] 有使用activeData功能时，是否为多选
 * @property {array|string|number} [activeData] 处于选中的activeData
 * @property {string} [activeFieldName=''] active对应data中哪个字段（如果指定该字段,activeData的元素即为该字段的值，为空时元素时整个data元素）
 * @property {func} [onActiveDataChange] 选中的activeData回调
 * @property {bool} [disabled=false] 是否禁止
 * @property {bool} [readonly=false] 是否只读（不可清空/删除标签）
 * @property {string} [labelFieldName='label'] 	文案在data中对应的字段名
 * @property {string} [valueFieldName='value'] 值在data中对应的字段名
 * @property {func} [onDelete] 删除某项回调
 * @property {bool} [clear] 是否可清空*(旧名称为isClear)*
 * @property {func} [onClear] 清空回调
 * @property {func} [setItemClassName] 设置对应数据的className*setItemClassName=(itemData, readonly) => return className*
 * @property {object} [OverlayTriggerProps={}] 使用tip的时候OverlayTrigger对应的参数
 * @property {func} [onMouseEnter] 鼠标移入标签事件*(data, index) => {}*
 * @property {func} [onMouseLeave] 鼠标移出标签事件*(data, index) => {}*
 * @property {titleline} 自定义组件属性
 * @property {func|element} [ClearComponent] 清空组件*(具体参数看案例)*
 * @property {object} [ClearComponentProps={}] ClearComponent的参数
 * @property {func|element} [AddComponent] 附加组件*(具体参数看案例)*
 * @property {object} [AddComponentProps={}] AddComponent的参数
 * @property {func} [tipRender] 根据数据内容自定义返回tip内容
 * @property {array} [componentSequence=['clear', 'add']] 自定义组件的顺序
 * @property {object} [classNameMap={}] 组件内对应结构的默认className(可以针对对应位置进行替换,具体参数见案例)
 * @property {object} [setNodeProps] 支持给特定dom node位置设置属性*(type, itemData) => object*
 * @see
 *
 * onChange typings:
 *     (event: any, data: any) => any
 *
 * ====
 *
 * onActiveDataChange typings:
 *     (event: any, value: any) => any
 *
 * ====
 *
 * onDelete typings:
 *     (event: any, deleteItem: any) => any
 *
 * ====
 *
 * onMouseEnter typings:
 *     (event: any, index: any) => any
 *
 * ====
 *
 * onMouseLeave typings:
 *     (event: any, index: any) => any
 *
 * ====
 *
 * tipRender typings:
 *     (props: any) => any
 *
 *
 * @example
 * &lt;ClearComponent
 key='clear'
    show={clearShow}
    onClick={onClear}
/&gt;
    *
    * &lt;AddComponent
key='add'
/&gt;
 *
 * classNameMap配置可见于：
 * https://git.code.oa.com/ads/spaui-basic_ui_components/tree/master/src/spaui-labels/src/js/config/classname_map.js
 */
var config = {
  data: {
    type: _spauiUtils.PropTypes.array.isRequired,
    defaultValue: []
  },
  multiple: {
    type: _spauiUtils.PropTypes.bool,
    defaultValue: true
  },
  activeData: {
    type: _spauiUtils.PropTypes.any
  },
  onChange: {
    type: _spauiUtils.PropTypes.func
  },
  onActiveDataChange: {
    type: _spauiUtils.PropTypes.func
  },
  activeFieldName: {
    type: _spauiUtils.PropTypes.string,
    defaultValue: ''
  },
  disabled: {
    type: _spauiUtils.PropTypes.bool,
    defaultValue: false
  },
  valueFieldName: {
    type: _spauiUtils.PropTypes.string,
    defaultValue: 'value'
  },
  labelFieldName: {
    type: _spauiUtils.PropTypes.string,
    defaultValue: 'label'
  },
  readonly: {
    type: _spauiUtils.PropTypes.bool,
    defaultValue: false
  },
  onDelete: {
    type: _spauiUtils.PropTypes.func
  },
  onClear: {
    type: _spauiUtils.PropTypes.func
  },
  clear: {
    type: _spauiUtils.PropTypes.bool,
    defaultValue: true
  },
  setItemClassName: {
    type: _spauiUtils.PropTypes.func
  },
  OverlayTriggerProps: {
    type: _spauiUtils.PropTypes.object,
    defaultValue: {
      trigger: 'hover',
      showDelayTime: 0,
      hideDelayTime: 0,
      placement: 'top'
    }
  },
  ClearComponent: {
    type: _spauiUtils.PropTypes.oneOfType([_spauiUtils.PropTypes.func, _spauiUtils.PropTypes.element]),
    defaultValue: _clear_component["default"]
  },
  ClearComponentProps: {
    type: _spauiUtils.PropTypes.object,
    defaultValue: {}
  },
  AddComponent: {
    type: _spauiUtils.PropTypes.oneOfType([_spauiUtils.PropTypes.func, _spauiUtils.PropTypes.element])
  },
  AddComponentProps: {
    type: _spauiUtils.PropTypes.object,
    defaultValue: {}
  },
  tipRender: {
    type: _spauiUtils.PropTypes.func
  },
  onMouseEnter: {
    type: _spauiUtils.PropTypes.func
  },
  onMouseLeave: {
    type: _spauiUtils.PropTypes.func
  },
  componentSequence: {
    type: _spauiUtils.PropTypes.array,
    defaultValue: ['clear', 'add']
  },
  classNameMap: {
    type: _spauiUtils.PropTypes.object,
    defaultValue: {}
  },
  setNodeProps: {
    type: _spauiUtils.PropTypes.func
  }
}; // 转化成PureComponent组件的配置

exports.config = config;
var configData = (0, _spauiUtils.formatProps)(config); // 导出

var propTypes = configData.propTypes;
exports.propTypes = propTypes;
var defaultProps = configData.defaultProps;
exports.defaultProps = defaultProps;
var _default = {
  config: config,
  propTypes: propTypes,
  defaultProps: defaultProps
};
exports["default"] = _default;